module.exports = __webpack_public_path__ + "static/media/tievo.403ce1e7.jpg";